module.exports = __webpack_public_path__ + "static/media/lydexLogo.f3be1d87.png";